import { Outlet } from 'react-router'
import { routes } from 'types/routes'
import { useTranslation } from 'react-i18next'
import PageLayout from 'layouts/page-layout/PageLayout.tsx'
import { PageTab } from 'layouts/page-layout/types.ts'
import { Layouts } from 'layouts/types.ts'
import useGetRouteLayout from 'hooks/useGetRouteLayout.ts'

const Support = () => {
  // i18n
  const { t } = useTranslation(['support', 'common'])

  // Check layout from routing
  const { layout } = useGetRouteLayout()

  // Tabs
  const tabs: PageTab[] = [
    { label: t(($) => $.contact.tab), path: routes.SUPPORT_CONTACT },
    { label: t(($) => $.faq.tab), path: routes.SUPPORT_FAQ },
    { label: t(($) => $.complaint.tab), path: routes.SUPPORT_COMPLAINT }
  ]

  if (layout === Layouts.EDIT_LAYOUT) {
    return <Outlet />
  }

  return (
    <PageLayout
      title={t(($) => $.nav.support, {
        ns: 'common'
      })}
      {...{ tabs }}
    >
      <Outlet />
    </PageLayout>
  )
}

export default Support
